<template>
  <div class="lawsjxlmtj">
    <sec-title Text="精品栏目推荐" class="text_center" />
    <div class="lawsjxlmtj_cont between">
      <div class="lmtj_video">
        <sub-title text="律师说法" class="video_title" />
        <div class="tjvi_top" v-if="videolist[0]" @click="tojumpvideo(videolist[0])">
          <ques-media type="video" :src="videolist[0].preview_pic" :duration="videolist[0].duration" class="tt_vi" />
          <div class="vi_li_title">
            {{ videolist[0].title | toEllipsisFilter(20) }}
          </div>
          <div class="videodec">
            {{ videolist[0].content | toEllipsisFilter(50) }}
          </div>
        </div>
        <div class="tjvi_botm between">
          <div
            class="tjvi_item"
            v-for="(item, index) in videolist.slice(1)"
            :key="index"
            @click="tojumpvideo(item)"
          >
            <ques-media type="video" :src="item.preview_pic" :duration="item.duration" class="tb_vi" />
            <div class="vi_li_title">
              {{ item.title | toEllipsisFilter(10) }}
            </div>
          </div>
        </div>
      </div>
      <div class="lmtj_r">
        <div class="lmtj_audio">
          <div class="audio_title between">
            <sub-title text="语音问答" />
            <div @click="tojumpaulist">更多></div>
          </div>
          <div class="audiolist between wrap">
            <div
              class="audi_item flex_start"
              v-for="(item, index) in audiolist"
              :key="index"
              @click="tojumpaudio(item)"
            >
              <div class="cover">
                <img :src="item.avatar" alt="" />
                <div class="play center">
                  <img src="../../../assets/laws/bf.png" alt="" />
                </div>
              </div>
              <div class="dec">
                <div class="bt ellipsis">{{ item.title }}</div>
                <div class="info between">
                  <div>{{ item.true_name }}</div>
                  <div class="center">
                    <img src="../../../assets/laws/st.png" alt="" />{{
                      item.duration
                    }}
                  </div>
                  <div class="center">
                    <img src="../../../assets/laws/ej.png" alt="" /><span>{{
                      item.view_num
                    }}</span
                    >人收听
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="lmtj_other">
          <div class="other_tit">其他关注</div>
          <div class="between">
            <div class="other_item">
              <div><img src="../../../assets/laws/other1.png" alt="" /></div>
              <div class="ot_tit">刑罚罪名</div>
              <div class="ot_de">刑罚罪名大全一览</div>
            </div>
            <div class="other_item">
              <div><img src="../../../assets/laws/other2.png" alt="" /></div>
              <div class="ot_tit">赔偿标准</div>
              <div class="ot_de">交通、工伤、损害赔偿计算</div>
            </div>
            <div class="other_item">
              <div><img src="../../../assets/laws/other3.png" alt="" /></div>
              <div class="ot_tit">办事指南</div>
              <div class="ot_de">政策及便民服务指南</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import secTitle from "../../home/components/secTitle";
import subTitle from "../../home/components/subTitle";
import quesMedia from "views/question/components/quesMedia";
export default {
  components: {
    secTitle,
    subTitle,
    quesMedia,
  },
  data: () => ({
    videolist: [],
    audiolist: [],
  }),
  beforeMount() {
    this.getvideolist();
    this.getaudiolist();
  },
  methods: {
    tojumpvideo(item) {
      this.$router.push({
        path: "/laws/videoimdet",
        query: {
          videoinId: item.id,
        },
      });
    },
    tojumpaudio(item) {
      this.$router.push({
        path: "/laws/audioimdet",
        query: {
          audioinId: item.id,
        },
      });
    },
    tojumpaulist() {
      this.$router.push({
        path: "/laws/audioclaim",
      });
    },
    getvideolist() {
      this.$http.laws
        .getvideolist({
          limit: 3,
          order: "hot",
          page: 1,
        })
        .then((res) => {
          this.videolist = res.data.data;
        });
    },
    getaudiolist() {
      this.$http.laws
        .getaudiolist({
          limit: 6,
          order: "hot",
          page: 1,
        })
        .then((res) => {
          this.audiolist = res.data.data;
        });
    },
  },
};
</script>

<style lang="scss" scope>
.lawsjxlmtj {
  width: 1200px;
  margin: 0 auto;
  padding: 50px 0;
  .lawsjxlmtj_cont {
    margin-top: 30px;
    align-items: flex-start;
    .lmtj_video {
      width: 490px;
      height: 100%;
      .video_title {
      }
      .vi_li_title {
        margin-top: 16px;
        font-size: 20px;
        color: #333333;
      }
      .tjvi_top {
        margin-top: 20px;
        .tt_vi {
          width: 490px;
          height: 330px;
        }
        .vi_li_title {
          margin-top: 26px;
        }
        .videodec {
          margin-top: 10px;
          font-size: 14px;
          color: #666666;
          line-height: 24px;
        }
      }
      .tjvi_botm {
        margin-top: 20px;
        .tb_vi {
          width: 236px;
          height: 172px;
          .svg_img {
            font-size: 34px;
          }
        }
      }
    }
    .lmtj_r {
      .lmtj_audio {
        width: 680px;
        height: 100%;
        .audio_title {
          padding-right: 28px;
          div{
            cursor: pointer;
          }
        }
        .audiolist {
          .audi_item {
            width: 330px;
            height: 100px;
            margin-top: 20px;
            padding: 18px 9px;
            background: #ffffff;
            box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
            .cover {
              width: 60px;
              height: 60px;
              border-radius: 50%;
              margin-right: 10px;
              overflow: hidden;
              position: relative;
              img {
                width: 100%;
                height: 100%;
              }
              .play {
                cursor: pointer;
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                background-color: rgba(0, 0, 0, 0.2);
                img {
                  width: 10px;
                  height: 16px;
                }
              }
            }
            .dec {
              width: 240px;
              .bt {
                font-size: 18px;
                color: #333333;
                line-height: 20px;
              }
              .info {
                width: 100%;
                color: #808080;
                font-size: 14px;
                margin-top: 10px;
                img {
                  margin-right: 5px;
                }
                span {
                  color: #d02020;
                }
              }
            }
          }
        }
      }
      .lmtj_other {
        margin-top: 30px;
        .other_tit {
          font-size: 20px;
          color: #333333;
        }
        .other_item {
          margin-top: 24px;
          text-align: center;
          width: 188px;
          height: 250px;
          padding-top: 40px;
          border-radius: 5px;
          .ot_tit {
            font-size: 16px;
            color: #333333;
            margin-top: 15px;
          }
          .ot_de {
            margin-top: 10px;
            font-size: 14px;
            color: #656565;
          }
          &:hover {
            border-bottom: 5px solid #0465ea;
            box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
          }
        }
      }
    }
  }
}
</style>